var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSliderNextArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 120,
    viewBox: "0 0 80 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1644_7197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 90L50 60L30 30",
    stroke: "#AAAAAA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1644_7197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 120)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSliderNextArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/slider_next_arrow.b22e3904.svg";
export { ForwardRef as ReactComponent };